import ProjectData from '@/data/ProjectData.ts'

export default [
    new ProjectData("project-1", "Untitled Mystery VR Game", "img/projects/UMVRG-thumbnail.jpg", 
    `
    <div class="paragraph">
     <strong>Welcome to 2044, 10 years since the police service was no longer public, cults are starting to rise all around the country. 

     You are a rookie inspector called Amy who starts her first day of work with her auntie Agatha, a freelance police officer because getting accepted nowadays in the private police force business is hard.
     
     What should be a simple suicide case of a paranoid man ends up uncovering a sinister plot, something that will change Amy’s life forever. 
    </div>

     <div class="paragraph center">
     <iframe class="youtube" src="https://www.youtube-nocookie.com/embed/RStpR08CNYQ" frameborder="0" allowfullscreen></iframe>
    </div>

    <div class="paragraph">
        Main features :
        <ul>
            <li>Adventure/Mystery Game for VR!</li>
            <li>Use your Virtual AR tools to investigate the case.</li>
            <li>Discover the mystery behind the paranoid man's death</li>
            <li>Compatible with almost every headset thanks to OpenXR!</li>
            <li>Features FMOD & Oculus Occlusion for Audio Immersion</li>
        </ul>
    </div>
    <div class="paragraph" >
    <div class="notice center">
    Available on <a href="https://othascarlet.itch.io/untitled-mystery-vr-game" target="_blank">Itch.io</a>.
    </div>
    </div>
    <div class="paragraph">
    Compatible With:<br/>
    <img class="pc-screenshot" src="img/Trademarks/SteamVR.png" alt="SteamVR Logo" />
    <img class="pc-screenshot" src="img/Trademarks/OpenXR.png" alt="OpenXR Logo" />
    </div>
    <div class="paragraph center">Screenshots:<br/>
        <img class="pc-screenshot" src="img/projects/UMVRG/pic-00.jpg" alt="Screenshot 1" />
        <img class="pc-screenshot" src="img/projects/UMVRG/pic-04.jpg" alt="Screenshot 2" />
        <img class="pc-screenshot" src="img/projects/UMVRG/pic-08.jpg" alt="Screenshot 3" />
        <img class="pc-screenshot" src="img/projects/UMVRG/pic-07.jpg" alt="Screenshot 4" />
    </div>
    
    <div class="small center">
    Steam, SteamVR, the Steam logo and the SteamVR logo are
    trademarks and/or registered trademarks of Valve Corporation in the U.S. and/or other countries.<br/>
   FMOD and the FMOD logo are trademarks and/or registered trademarks of Firelight Technologies Pty Ltd in the U.S. and/or other countries.<br/>
   Oculus and its logo are trademarks or registered trademarks of FACEBOOK TECHNOLOGIES, LLC, Inc in the US and elsewhere.<br/>
   OpenXR™ is a trademark owned by The Khronos Group Inc. and is registered as a trademark in China, the European Union, Japan and the United Kingdom<br/>
   </div>
    `, "#23bd69", true, true),
];